<script>
import ChannelItem from 'dashboard/components/widgets/ChannelItem.vue';
import router from '../../../index';
import PageHeader from '../SettingsSubPageHeader.vue';
import { mapGetters } from 'vuex';
import globalConfigMixin from 'shared/mixins/globalConfigMixin';

export default {
  components: {
    ChannelItem,
    PageHeader,
  },
  mixins: [globalConfigMixin],
  data() {
    return {
      enabledFeatures: {},
    };
  },
  computed: {
    account() {
      return this.$store.getters['accounts/getAccount'](this.accountId);
    },
    channelList() {
      const { apiChannelName, apiChannelThumbnail } = this.globalConfig;
      const allChannels = [
        { key: 'website', name: 'Website', feature: 'channel_website' },
        { key: 'facebook', name: 'Messenger', feature: 'channel_facebook' },
        { key: 'zalooa', name: 'ZaloOa', feature: 'channel_zalooa' },
        { key: 'zalopersonal', name: 'Zalo Personal', feature: 'channel_zalopersonal' },
        { key: 'whatsapp', name: 'WhatsApp', feature: 'channel_whatsapp' },
        { key: 'sms', name: 'SMS', feature: 'channel_sms' },
        { key: 'email', name: 'Email', feature: 'channel_email' },
        {
          key: 'api',
          name: apiChannelName || 'API',
          thumbnail: apiChannelThumbnail,
          feature: 'channel_api'
        },
        { key: 'telegram', name: 'Telegram', feature: 'channel_telegram' },
        { key: 'line', name: 'Line', feature: 'channel_line' },
      ];
      
      return allChannels.filter(channel => {
        if (!channel.feature) return true;
        return this.enabledFeatures[channel.feature] || false;
      });
    },
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      globalConfig: 'globalConfig/get',
    }),
  },
  mounted() {
    this.initializeEnabledFeatures();
  },
  methods: {
    async initializeEnabledFeatures() {
      try {
        if (this.account && this.account.features) {
          this.enabledFeatures = this.account.features;
        } else {
          const account = await this.$store.dispatch('accounts/getById', this.accountId);
          this.enabledFeatures = account.features || {};
        }
      } catch (error) {
        console.error('Failed to load enabled features:', error);
        this.enabledFeatures = {};
      }
    },
    initChannelAuth(channel) {
      const params = {
        sub_page: channel,
        accountId: this.accountId,
      };
      router.push({ name: 'settings_inboxes_page_channel', params });
    },
  },
};
</script>

<template>
  <div
    class="h-full w-full"
  >
    <PageHeader
      class="max-w-4xl"
      :header-title="$t('INBOX_MGMT.ADD.AUTH.TITLE')"
      :header-content="
        useInstallationName(
          $t('INBOX_MGMT.ADD.AUTH.DESC'),
          globalConfig.installationName
        )
      "
    />
    <div class="flex flex-wrap gap-3 max-w-3xl mx-auto justify-center mt-6">
      <ChannelItem
        v-for="channel in channelList"
        :key="channel.key"
        :channel="channel"
        :enabled-features="enabledFeatures"
        class="w-32"
        @channel-item-click="initChannelAuth"
      />
    </div>
  </div>
</template>
